<script>
import XEUtils from 'xe-utils'

export default {
  data() {
    return {
      data: {},
      show: false,
      rules: {
        score: [{ required: true, trigger: 'change', message: '请输入推荐评分' }],
      },
      name: '',
      loading: false
    }
  },
  methods: {
    display(event) {
      this.$set(this, 'data', XEUtils.clone(event.data, true))
      this.$set(this, 'name', '更新推荐评分')
      this.$set(this, 'show', true)
      this.$set(this, 'loading', false)
    },
    handleToRecommend(row) {
      let type = 'info'
      let label = '化验室'
      if (row.type === 'Tenant') {
        type = 'success'
        label = '企业'
      } else if (row.type === 'Platform') {
        type = 'primary'
        label = '场站'
      } else if (row.type === 'TenantProduct') {
        type = 'warning'
        label = '报价'
      } else if (row.type === 'Park') {
        type = 'danger'
        label = '园区'
      }
      return { type, label }
    },
    handleSave() {
      this.$refs.formRef.validate((vali) => {
        if (vali) {
          this.$set(this, 'loading', true)
          const params = {
            uuid: this.data.uuid,
            score: this.data.score,
            type: this.data.type,
            id: this.data.id
          }
          this.$axios.post('/account/shop/recommend/score', params).then(() => {
            this.$message.success({ showClose: true, message: '更新成功' })
            this.$emit('init')
            this.$set(this, 'loading', false)
            this.$set(this, 'show', false)
          }).catch(() => {
            this.$set(this, 'loading', false)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<template>
  <el-dialog :visible.sync="show" :title="name" width="900px">
    <el-form ref="formRef" size="small" :model="data" label-width="auto" label-position="right" :rules="rules">
      <el-form-item prop="name" label="名称">
        {{ data.name }}
      </el-form-item>
      <el-form-item prop="type" label="类型">
        <el-tag :type="handleToRecommend(data).type" size="mini" effect="dark">
          {{ handleToRecommend(data).label }}
        </el-tag>
      </el-form-item>
      <el-form-item prop="score" label="评分">
        <el-input-number v-model="data.score" :min="0" :max="1000000" :step="0.1" step-strictly></el-input-number>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <div style="text-align: center">
        <el-button type="primary" style="width: 100%" @click="handleSave" :loading="loading">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>